<!--
 * @Description:
 * @Author: luokang
 * @Date: 2023-12-11 16:27:57
-->
<template>
  <div class='step_two'>
    <div class="step_two_title"><p>1</p><p>{{ $lang('获取验证码') }}</p></div>
    <section class="step_two_box">
      <div class="box_left">
        <p>{{$lang('方式一')}}</p>
        <p>{{$lang('使用手机验证应用扫描一下二维码，获取6位验证码')}}</p>
        <div class="box_left_img">
          <img :src="googleInfo.qrCode" alt="绑定设备二维码">
        </div>
      </div>
      <div class="box_right">
        <p>{{$lang('方式二')}}</p>
        <p>{{$lang('在手机验证应用中手动输入以下账号密钥，获取6位验证码')}}</p>
        <div class="box_right_content">
          <p>{{ $lang('账号') }}</p>
          <p>{{ googleInfo.account }}</p>
          <p>{{ $lang('密钥') }}</p>
          <p>
            {{ googleInfo.secretKey }}
            <span @click="copy" class="copy_btn">{{ $lang('复制') }}</span>
          </p>
        </div>
        </div>
    </section>
    <section class="step_three_box">
      <div class="step_two_title"><p>2</p><p>{{ $lang('输入验证码以完成绑定') }}</p></div>
      <label class="step_two_label"><span>*</span><span>{{ $lang('验证码') }}</span></label>
      <el-input class="step_two_input" v-model="stepData.code" @change="$emit('codeSuccess',stepData.code)" :placeholder="$lang('请输入6位验证码')" clearable maxlength="6"></el-input>
      <p class="step_error" v-show="checkErr">
        <img src="@/assets/images/codeErr.png" alt="报错提示">
        <span>{{ $lang('验证码错误，请重新输入') }}</span>
      </p>
    </section>
  </div>
</template>
<script>

export default {
  components: {},
  props: {
    googleInfo: {
      type: Object,
      default: () => {}
    },
    checkErr: {
      type: Boolean,
      default: false
    }
  },
  name: 'StepTwo',
  data() {
    return {
      stepData: {
        code: ''
      }
    }
  },
  computed: {},
  watch: {},
  methods: {
    copy() {
      const value = this.googleInfo.secretKey
      const oInput = document.createElement('input')
      oInput.value = value
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: this.$lang('复制成功'),
        type: 'success'
      })
      oInput.remove()
    }
  },
  created() {

  },
  mounted() {

  }
}
</script>
<style scoped lang='scss'>
 /* @import url(); 引入css类 */
.step_two{
  height: 466px;
  padding: 30px 33px 8px;
  .step_two_title{
    display: flex;
    p:nth-child(1){
      width: 25px;
      height: 25px;
      border-radius: 50%;
      color: #000;
      border: 1px solid #000;
      font-size: 16px;
      line-height: 25px;
      text-align: center;
      margin-right: 10px;
    }
    p:nth-child(2){
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 600;
      text-align: left;
      color: #1f1f1f;
    }
  }
  .step_two_box{
    display: flex;
    justify-content: space-between;

     .box_left{
      background: #ffffff;
      border: 1px solid #e4e4e4;
      border-radius: 10px;
      width: 390px;
      padding: 16px 0;
      box-sizing: border-box;
      p{
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 600;
        text-align: center;
        margin: 0
      }
      p:nth-child(1){
        color: #1f1f1f;
        margin-bottom: 6px;
      }
      p:nth-child(2){
        color: #61666d;
        margin-bottom: 16px;
      }
      .box_left_img{
        text-align: center;
        img{
          margin: auto;
          width: 122px;
          height: 122px;
        }
      }
    }
    .box_right{
      background: #ffffff;
      border: 1px solid #e4e4e4;
      border-radius: 10px;
      width: 390px;
      padding: 16px 12px;
      box-sizing: border-box;
      p{
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 600;
        text-align: center;
        margin: 0
      }
      p:nth-child(1){
        color: #1f1f1f;
        margin-bottom: 6px;
      }
      p:nth-child(2){
        color: #61666d;
        margin-bottom: 26px;
      }
      .box_right_content{
       padding: 12px;
       background: #fafafa;
       border-radius: 8px;
       p:nth-child(odd){
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #61666d;
        line-height: 14px;
        margin-bottom: 7px;
       }
       p:nth-child(even){
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #61666d;
        line-height: 14px;
        margin-bottom: 18px;
       }
       p:last-child{
        margin-bottom: 0;
       }
      }
      .copy_btn{
        color:#3370FF;
        cursor: pointer;
      }
    }
  }
  .step_two_label{
    span:nth-child(1){
      color: #f00;
    }
    span:nth-child(2){
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 600;
      color: #000;
    }
  }
  .step_three_box{
    margin-top: 40px;
  }
  .step_error{
    margin: 0;
    display: flex;
    align-items: center;
    img{
      width: 12px;
      height: 12px;
      margin-right: 6px;
    }
    span{
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Regular;
      color: #ff1a2c;
      line-height: 17px;
    }
  }
}
::v-deep{
  .step_two_input{
    width: 387px !important;
    margin: 7px 0 5px;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 10px;
    display: block;
    .el-input__inner{
      color: #000 !important;
    }
  }
}
</style>
